import { protectedApi } from "../common/protectedApi";
import { APIS } from "../constants/apiConstant";

export const mapClientProfileFromApi = (row) => {
  if (!row) return null;
  return {
    id: row.id,
    clientName: row.clientName || "",
    companyName: row.companyName || "",
    gstNumber: row.gstNumber || "",
    hsnCode: row.hsnCode || "",
    contactNumber: row.contactNumber || "",
    companyAddress: row.companyAddress || "",
    emailId: row.emailId || "",
    ccEmail: row.ccEmail || "",
    bccEmail: row.bccEmail || "",
    projectInitiationDate: row.projectInitiationDate || "",
    onboardedCompanyId: row.onboardedCompanyId != null ? String(row.onboardedCompanyId) : "",
    onboardedCompanyName: row.onboardedCompanyName || "",
    resources: Array.isArray(row.resources) ? row.resources : [],
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  };
};

const buildPayload = (form) => ({
  clientName: form.clientName,
  companyName: form.companyName,
  gstNumber: form.gstNumber,
  hsnCode: form.hsnCode,
  contactNumber: form.contactNumber,
  companyAddress: form.companyAddress,
  emailId: form.emailId,
  ccEmail: form.ccEmail,
  bccEmail: form.bccEmail,
  projectInitiationDate: form.projectInitiationDate,
  onboardedCompanyId: form.onboardedCompanyId,
  onboardedCompanyName: form.onboardedCompanyName,
  resources: form.resources,
});

export const fetchClientProfiles = async () => {
  const response = await protectedApi({ url: APIS.CLIENT_MANAGEMENT, method: "GET" });
  const clients = response?.data?.data?.clients || [];
  return clients.map(mapClientProfileFromApi).filter(Boolean);
};

export const createClientProfileApi = async (form) => {
  const response = await protectedApi({
    url: APIS.CLIENT_MANAGEMENT,
    method: "POST",
    data: buildPayload(form),
  });
  return mapClientProfileFromApi(response?.data?.data?.client);
};

export const updateClientProfileApi = async (clientId, form) => {
  const url = APIS.CLIENT_MANAGEMENT_BY_ID.replace(":clientId", String(clientId));
  const response = await protectedApi({
    url,
    method: "PUT",
    data: buildPayload(form),
  });
  return mapClientProfileFromApi(response?.data?.data?.client);
};

export const deleteClientProfileApi = async (clientId) => {
  const url = APIS.CLIENT_MANAGEMENT_BY_ID.replace(":clientId", String(clientId));
  await protectedApi({ url, method: "DELETE" });
};
